import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@chakra-ui/react";
/** This component returns green dot if value is true else returns red dot  */
export const BooleanDot = (props) => {
    const { value } = props;
    return (_jsx(Box, { bg: value ? "green.600" : "red.500", width: "7px", minHeight: "7px", borderRadius: "50%", className: value ? "bg-success" : "bg-warning" }));
};
//# sourceMappingURL=booleanDot.js.map